import {ProductComboProvider} from '@/context/ProductCombo/ProductComboContext'
import {CreateProductCombo} from './CreateProductCombo'

/**
 * Reusable Product Combo editor shell backed by ProductCombo context.
 * @param {{
 *   initialState?: import('@/types/productComboTypes').ProductCombo,
 *   initialStep?: number,
 * }} props
 * @returns {JSX.Element}
 */
export const ProductComboEditor = ({initialState, initialStep}) => {
  return (
    <ProductComboProvider initialState={initialState} initialStep={initialStep}>
      <CreateProductCombo />
    </ProductComboProvider>
  )
}
